export default __webpack_public_path__ + "f8b0c54109a21bfd9f30164743980904.png";